export const buildBaseEventData = (primaryCategory, eventName) => {
  const baseObject = {
    category: { primaryCategory },
    eventInfo: { eventName },
  };
  return baseObject;
};

export const buildBcomAnalyticsEvent = (primaryCategory, eventName, { omsId, productName, brand }) => {
  const eventData = buildBaseEventData(primaryCategory, eventName);

  if (omsId) {
    eventData.item = [{
      productInfo: {
        sku: `${omsId}`,
        productName,
        manufacturer: `${brand}`,
        productType: 'merchandise',
      },
    }];
  }

  return eventData;
};

export const buildCategoryData = (omnitureInfo) => ({
  primaryCategory: omnitureInfo.primaryCategory,
  subCategory1: omnitureInfo.subCategory1,
  subCategory2: omnitureInfo.subCategory2 || omnitureInfo.subCategory1,
});
